import React from "react";
import { Controller } from "react-hook-form";
import type { PathArray } from "common/utils/formStructure";
import { SubmissionDefaultValueFieldType } from "../../../../../../../../generated/graphql";
import { useSubmissionDefaultValueOptions } from "../../../../../../../../hooks/useSubmissionDefaultValueOptions";
import Select from "../../../../../../../Inputs/Select";
import {
  getUiSchemaPropertyFormPath,
  useBuilderFormContext,
  useBuilderWatch,
} from "../../../form/form";
import { useCustomMapGeometryIds } from "./hooks/useCustomMapGeometryIds";

type NumberDynamicDefaultInputProps = {
  fieldPath: PathArray;
  isReadOnly: boolean;
};

export function NumberDynamicDefaultInput({
  fieldPath,
  isReadOnly,
}: NumberDynamicDefaultInputProps) {
  const { control } = useBuilderFormContext();

  const defaultValuePathPropertyFormPath = getUiSchemaPropertyFormPath(
    fieldPath,
    "defaultValuePath",
  );
  const defaultValuePath = useBuilderWatch(defaultValuePathPropertyFormPath);

  const customMapIds = useCustomMapGeometryIds();

  const { options, loading, error } = useSubmissionDefaultValueOptions({
    fieldType: SubmissionDefaultValueFieldType.NUMBER,
    customMapIds,
  });

  return (
    <Controller
      control={control}
      name={defaultValuePathPropertyFormPath}
      render={({ field }) => {
        return (
          <Select
            label="Dynamic default value"
            value={defaultValuePath ?? null}
            isClearable={true}
            name={defaultValuePathPropertyFormPath}
            options={options}
            isLoading={loading}
            error={error?.message}
            onChange={value => {
              field.onChange(value ?? undefined);
            }}
            disabled={isReadOnly}
          />
        );
      }}
    />
  );
}
